import client from "./client";
export const applyToJob = (jobId, formData) => client.post(`/applications/apply/${jobId}`, formData);
export const getAllApplications = () => client.get("/applications/all");
export const getMyApplications = () => client.get("/applications/mine");
export const shortlistApplicant = (id) => client.post(`/applications/${id}/shortlist`);
export const updateApplicationStatus = (id, status) => client.put(`/applications/${id}/status`, { status });
